import { render, staticRenderFns } from "./visit.vue?vue&type=template&id=c13872fc&scoped=true"
import script from "./visit.vue?vue&type=script&lang=js"
export * from "./visit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13872fc",
  null
  
)

export default component.exports